




























































import { Component, Vue, Watch } from "vue-property-decorator";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import PositionDto from "@/models/Positions/PositionDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import RateCardPositionDto from "@/models/RateCardPositions/RateCardPositionDto";
import CreateRateCardPositionRequest from "@/models/RateCardPositions/CreateRateCardPositionRequest";

@Component({
  name: "AgencyRateCardPositionCreate",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  position: PositionDto = new PositionDto();
  chargeRate = 0;
   
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.position = new PositionDto();
      this.chargeRate = 0;
    }
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateRateCardPositionRequest();
    request.positionId = this.position.id;
    request.chargeRate = this.chargeRate;
    await AgencySettingsModule.createRateCardPosition(request);
    this.dialog = false;
  }
}
